(ns manage.product-selector-page.sections.exclusion
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Paper$default" :as Paper]
            ["@mui/material/Stack$default" :as Stack]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.form :as form]
            [common.widgets.form-field :refer [form-field]]
            [manage.product-selector-page.hooks :as hooks]
            [manage.product-selector-page.widgets :as widgets]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(def dynamic-property-options
  [{:value "user-last-viewed" :label "Last viewed products"}
   {:value "user-last-basketed" :label "Last basketed products"}
   {:value "user-last-purchased" :label "Last purchased products"}])

(defui dynamic-property
  [{:keys [control field-name]}]
  ($ form-field
     {:label "Dynamic property"}
     ($ form/autocomplete-field
        {:control control
         :name field-name
         :field-props {:options dynamic-property-options}})))

(defui lookback-days
  [{:keys [control field-name]}]
  ($ form-field
     {:label "Last # of days"}
     ($ form/form-text-field
        {:control control
         :name field-name
         :on-change-fn js/parseInt
         :field-props {:type "number"
                       :inputProps #js {:min 1
                                        :max 30}}})))

(defui dynamic-exclude-clause
  [{:keys [control field-name]}]
  ($ Box {:sx #js {:display "grid"
                   :gridTemplateColumns "1fr 1fr"
                   :flex 1
                   :gap 1}}
     ($ dynamic-property {:control control :field-name (str field-name ".type")})
     ($ lookback-days {:control control :field-name (str field-name ".lookback-days")})))

(defui manual-exclude-clause
  [{:keys [control field-name]}]
  ($ form-field
     {:label "SKU"
      :sx #js {:flex 1}}
     ($ rhf/Controller
        {:control control
         :name (str field-name ".sku")
         :render (fn [^js props]
                   (let [{{:keys [value]} :field} (->clj props)]
                     ($ :span value)))})))

(defui exclude-clause
  [{:keys [type control field-name on-delete]}]
  ($ Paper
     {:component Stack
      :elevation 0
      :direction "row"
      :justifyContent "space-between"
      :sx #js {:gap 1
               :px 2
               :py 1.5}}
     (if (= type "sku")
       ($ manual-exclude-clause {:control control :field-name field-name})
       ($ dynamic-exclude-clause {:control control :field-name field-name}))
     ($ IconButton
        {:onClick on-delete
         :sx #js {:alignSelf "flex-end"}}
        ($ Icon "delete"))))

(defui edit []
  (let [{:keys [control]} (form/use-form-context)
        field-name "exclude"
        {:keys [fields append remove]} (form/use-field-array #js {:control control
                                                                  :name field-name})
        has-dynamic-clause? (some #(not= (.-type %) "sku") fields)
        excluded-products (->> (->clj fields)
                               (keep #(when (:sku %) %)))]
    ($ Stack
       {:gap 2}
       (for [[idx field] (mc/seq-indexed fields)]
         ($ exclude-clause
            {:key (.-id field)
             :type (.-type field)
             :control control
             :field-name (str field-name "[" idx "]")
             :on-delete #(remove idx)}))
       ($ Stack
          {:direction "row"
           :gap 1}
          ($ Button
             {:variant "text"
              :startIcon ($ Icon "add")
              :onClick #(append (->js hooks/initial-dynamic-exclude-clause))
              :disabled has-dynamic-clause?
              :sx #js {:alignSelf "flex-start"}}
             "Add dynamic property")
          ($ Button
             {:variant "text"
              :startIcon ($ Icon "add")
              :onClick (fn []
                         (rf/dispatch
                          [:modal/open {:id :product-modal
                                        :props {:on-select (fn [p]
                                                             (append #js {:type "sku" :sku (:sku p)})
                                                             (rf/dispatch [:modal/close]))
                                                :disabled-products excluded-products}}]))
              :sx #js {:alignSelf "flex-start"}}
             "Add manual item")))))

(defui read-dynamic-exclude-clause [{:keys [exclude]}]
  (let [{:keys [type lookback-days]} exclude
        type->label (->> dynamic-property-options
                         (map (juxt :value :label))
                         (into {}))]
    ($ form-field
       {:label (get type->label type)}
       ($ :span (str "Last " lookback-days " days")))))

(defui read []
  (let [{:keys [control]} (form/use-form-context)
        exclude (rhf/useWatch #js {:name "exclude" :control control})
        {manual-items true dynamic-items false} (group-by #(= (:type %) "sku") (->clj exclude))]
    ($ Stack {:gap 2}
       (for [[idx item] (mc/seq-indexed dynamic-items)]
         ($ read-dynamic-exclude-clause {:key idx :exclude item}))
       (when (seq manual-items)
         ($ form-field
            {:label "Manual products"}
            (str/join ", " (map :sku manual-items))))
       (when (empty? exclude)
         ($ widgets/empty-section-message {:step-label "product exclusion"})))))

(defui exclusion []
  (let [{:keys [mode]} (form/use-form-context)]
    ($ widgets/section-card
       {:title "Exclude products"
        :tooltip "Decide which products should be excluded. Pick them manually or
                  use event-based rules dynamic properties, like “last viewed”."}
       (if (= mode :read)
         ($ read)
         ($ edit)))))
